import { Injectable } from '@angular/core';

@Injectable()
export class AppGlobals {
  readonly quickSight = 'quicksight';
  readonly adminRole = 'ADMIN';
  readonly defaultPartner = 'comcast';
  readonly dashboardDescriptionRole = 'COMCAST-TECHNICAL-WRITERS';
  readonly superAdminRole = 'SUPER-ADMIN';
  readonly mvpdTeamRole = 'MVPD-TEAM';
  readonly startDate = 'dashboardHitsStartDate';
  readonly endDate = 'dashboardHitsEndDate';
  readonly portalMessageStartTime = 'portalMessagesStartDate';
  readonly portalMessageEndTime = 'portalMessagesEndDate';
  readonly changeCategoryOrder = 'category';
  readonly changeMainMenuOrder = 'mainmenu';
  readonly changeSubMenuOrder = 'submenu';
  readonly changeDashboardOrder = 'dashboard';
  readonly userSuggestions = 'suggestion';
  readonly userBugs = 'bug';
  readonly userRole = 'role';
  readonly releaseFeature = 'feature';
  readonly releaseFix = 'fix';
  readonly stagingDashboard = 'Staging';
  readonly productionDashboard = 'Production';
  readonly comcastGeneralRole = 'comcast-general';
  readonly comcastGlobalRole = 'comcast-global';
  readonly contentRestrictedPartners = ['comcast', 'sky-group'];
  readonly faqStates = [
    'Active',
    'In Progress',
    'Abandoned',
    'Hidden',
    'Published',
    'Archived',
  ];
}
